import { render, staticRenderFns } from "./commonChose.vue?vue&type=template&id=0a8268cb&scoped=true&"
import script from "./commonChose.vue?vue&type=script&lang=js&"
export * from "./commonChose.vue?vue&type=script&lang=js&"
import style0 from "./commonChose.vue?vue&type=style&index=0&id=0a8268cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8268cb",
  null
  
)

export default component.exports